module.exports = __webpack_public_path__ + "static/img/port.d0d95ae3.png";